let teamCount: number;

// convert Beersheet csv to draftaid json format
export function convertBeersheet(csv: string) {
  let players: any[] = [];
  let json = { format: 'beersheets', rankings: players };
  let rows: string[] = csv.split('\r\n');
  for (let i = 1; i < rows.length - 1; i++) {
    let stats = rows[i].split(',');
    // BeerSheets csv format is (2022):
    // 0. Name
    // 1. Pos
    // 2. Tm/Bye
    // 3. Average
    // 4. Stdev
    // 5. Rank
    // 6. Tier
    // 7. ECR
    // 8. ECR VS. ADP
    // 9. PS
    // 10. Baseline
    // 11. Args
    if (i == 1) {
      teamCount = parseInt(stats[11]);
    }
    json.rankings.push({
      name: stats[0],
      tier: stats[6],
      rank: calculate_ecr(stats[7]),
      positional_rank: stats[1].concat(stats[5]),
      team: stats[2].split('/')[0],
      bye_week: stats[2].split('/')[1],
      position: stats[1],
    });
  }
  return json;
}

// Given an Expert Consensus Ranking (ecr), calculate the overall rank of the player
// BeerSheets provides this as $ROUND_NUMBER|$PICK_NUMBER, based on the number of teams you gave the wizard
// For example, Jonathan Taylor is 1|0.1, indicating he's a first round, first pick
// To calculate the overall rank we'll need to do ((round number - 1) * number of teams) + pick number
// e.g., Jonathan Taylor would be (1 - 1) + 1 = 1
function calculate_ecr(ranking) {
  let rp = ranking.split('|');
  if (rp[0] == '') {
    return 9001;
  }
  let r: number = parseInt(rp[0]);
  let p: number = parseInt(rp[1]);
  return (r - 1) * teamCount + p;
}
